/**
 * Static font delivery for TanStack Start (no next/font).
 * System stacks in tokens.css render immediately; optional web fonts enhance metrics.
 */
export const FONT_STYLESHEET_HREF =
  'https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400..900&family=Inter+Tight:wght@400..700&family=JetBrains+Mono:wght@400..700&display=swap';

export const fontHeadLinks = [
  { rel: 'preconnect' as const, href: 'https://fonts.googleapis.com' },
  {
    rel: 'preconnect' as const,
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous' as const,
  },
  {
    rel: 'stylesheet' as const,
    href: FONT_STYLESHEET_HREF,
  },
];
